<template>
  <div class="content_con">
    <div class="form_con" v-if="!zhucesuccess">
      <div class="title_bg">
        <img src="../../../assets/img/appImg/meida_topbg.png" />
        <div class="title_w">
          <p>如梦 如戏 乌镇</p>
          <p style="font-size: 5px">Beyond the Real, All Wuzhen's a Stage!</p>
        </div>
      </div>
      <div class="line"></div>
      <div class="title">{{ mediaSc.webName }}</div>

      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="80px"
        class="demo-formData"
      >
        <p class="form_title">基本信息</p>
        <el-form-item label="姓名" prop="regName" label-width="60px">
          <el-input v-model="formData.regName" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender" label-width="60px">
          <el-radio-group v-model="formData.gender">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上传图片验证码" label-width="120px">
          <el-input
            v-model="regImgCode"
            auto-complete="off"
            placeholder="验证码"
            style="width: 50%"
            @input="handleRegImgCode"
          >
          </el-input>
          <div class="login-code">
            <img :src="codeUrlimg" @click="getCodeImg" class="login-code-img" />
          </div>
        </el-form-item>
        <el-form-item
          label="照片"
          prop="regImg"
          class="vertical-layout"
          label-width="60px"
          style="border: none"
        >
          <div @click="handleHasUpload">
            <ImageUpload
              :disabled="regImgDisabled"
              @input="uploadRegImg"
              @remove="handleImageRemove"
              :code="regImgCode"
              :limit="1"
              :uuid="uuidImg"
              :key="timeStamp"
              :value="formData.regImg"
            />
          </div>
        </el-form-item>

        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="formData.idCard" placeholder="身份证号"></el-input>
        </el-form-item>
        <el-form-item label="联系地址" prop="address">
          <el-input
            v-model="formData.address"
            placeholder="联系地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="工作单位" prop="unitName">
          <el-input
            v-model="formData.unitName"
            placeholder="工作单位"
          ></el-input>
        </el-form-item>
        <el-form-item label="职务" prop="position" label-width="60px">
          <el-input v-model="formData.position" placeholder="职务"></el-input>
        </el-form-item>
        <el-form-item label="记者证号" prop="pressCard">
          <el-input
            v-model="formData.pressCard"
            placeholder="记者证号"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请种类" prop="applyType">
          <el-checkbox-group v-model="formData.applyType">
            <el-checkbox label="文字记者"></el-checkbox>
            <el-checkbox label="摄影记者"></el-checkbox>
            <el-checkbox label="电视记者"></el-checkbox>
          </el-checkbox-group>
          <span>其他</span
          ><el-input
            v-model="other"
            style="width: 50%"
            placeholder="其他"
            @blur="handleOther"
          ></el-input>
        </el-form-item>

        <el-form-item label="移动电话" prop="phone">
          <el-input v-model="formData.phone" placeholder="移动电话"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="email">
          <el-input v-model="formData.email" placeholder="电子邮箱"></el-input>
        </el-form-item>
        <p
          style="
            width: 100vw;
            background: #f0f1f2;
            margin-left: -1.3333rem;
            height: 0.5rem;
            margin-bottom: 1rem;
          "
        ></p>
        <p class="form_title">入住要求</p>
        <el-form-item label="住宿要求" required class="vertical-layout">
          <el-date-picker
            v-model="formData.date"
            type="daterange"
            start-placeholder="入住日期"
            end-placeholder="离开日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="拟采访嘉宾" prop="interview" label-width="100px">
          <el-input
            v-model="formData.interview"
            placeholder="拟采访嘉宾"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="拟发布专题内容及篇幅"
          prop="specialTopic"
          class="vertical-layout"
          label-width="170px"
        >
          <el-input
            v-model="formData.specialTopic"
            placeholder="拟发布专题内容及篇幅"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="拟发布时间"
          class="vertical-layout"
          label-width="100px"
          prop="publishTime"
        >
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="formData.publishTime"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="是否有媒体购票需求"
          prop="ticketDemand"
          label-width="160px"
        >
          <el-radio-group v-model="formData.ticketDemand">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="验证码"
          prop="code"
          v-if="captchaEnabled"
          label-width="70px"
        >
          <el-input
            v-model="formData.code"
            auto-complete="off"
            placeholder="验证码"
            style="width: 50%"
            @keyup.enter.native="handleLogin"
          >
          </el-input>
          <div class="login-code">
            <el-button
              style="
                background: #165dff;
                color: #fff;
                height: 40px;
                border-radius: 0;
              "
              @click="getCodeBtn"
              v-if="!showCodeImg"
              >获取验证码</el-button
            >
            <img
              v-if="showCodeImg"
              :src="codeUrl2"
              @click="getCode"
              class="login-code-img"
            />
          </div>
        </el-form-item>
        <el-checkbox v-model="formData.zhuce" style="margin: 0px 0px 25px 0"
          >我已阅读</el-checkbox
        ><span
          @click="handleZC"
          style="color: #165dff; cursor: pointer; font-size: 14px"
          >{{ mediaSc.webName }}</span
        >
      </el-form>
      <el-button
        style="
          background: #165dff;
          color: #fff;
          width: 100%;
          height: 48px;
          border-radius: 2rem;
        "
        @click="onSubmit"
        >提交</el-button
      >
    </div>
    <div class="success_con" v-if="zhucesuccess">
      <div><img src="../../../assets/img/success.png" /></div>
      <div class="succsee_title">提交成功</div>
      <div class="succsee_word">审核结果将发送到您的邮箱，请及时查收</div>
      <div class="succsee_word">点击确定将返回<span>首页</span></div>
      <div class="btn_con">
        <el-button
          style="
            background: #165dff;
            color: #fff;
            font-size: 1.3333rem;
            border-radius: 8.3333rem;
          "
          @click="toback"
          >确定</el-button
        >
      </div>
    </div>
    <el-dialog
      :visible="dialogVisibleZC"
      title="注册须知"
      width="80%"
      append-to-body
      center
      :show-close="false"
    >
      <div class="dialog_content">
        <p v-html="mediaSc.webNote"></p>
      </div>
      <div class="dialog_btn" @click="dialogVisibleZC = false">确定</div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getCodeImg,
  addMediaRegistry,
  getMediaRegistryConfig,
} from '@/assets/api';
import ImageUpload from '@/components/ImageUpload';
import { newproxyPut } from '@/utils/newproxy';
export default {
  components: {
    ImageUpload,
  },
  data() {
    return {
      captchaEnabled: true,
      codeUrl: '',
      formData: {
        regName: '',
        gender: '',
        regImg: '',
        idCard: '',
        address: '',
        unitName: '',
        position: '',
        pressCard: '',
        applyType: [],
        phone: '',
        email: '',
        date: [],
        interview: '',
        specialTopic: '',
        publishTime: null,
        ticketDemand: null,
        code: '',
        uuid: '',
      },
      other: '',
      rules: {
        regName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' },
        ],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        regImg: [{ required: true, message: '请上传图片', trigger: 'change' }],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入联系地址', trigger: 'blur' },
        ],
        unitName: [
          { required: true, message: '请输入工作单位', trigger: 'blur' },
        ],
        position: [{ required: true, message: '请输入职务', trigger: 'blur' }],
        pressCard: [
          { required: true, message: '请输入记者证号', trigger: 'blur' },
        ],
        applyType: [
          { required: true, message: '请选择申请种类', trigger: 'change' },
        ],
        phone: [{ required: true, message: '请输入移动电话', trigger: 'blur' }],
        email: [{ required: true, message: '请输入电子邮箱', trigger: 'blur' }],
        date: [
          {
            type: 'date',
            required: true,
            message: '请选择住宿日期',
            trigger: 'change',
          },
        ],
        interview: [
          { required: true, message: '请输入拟采访嘉宾', trigger: 'blur' },
        ],
        specialTopic: [
          {
            required: true,
            message: '请输入拟发布专题内容及篇幅',
            trigger: 'blur',
          },
        ],
        publishTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change',
          },
        ],
        ticketDemand: [
          {
            required: true,
            message: '请选择是否有媒体购票需求',
            trigger: 'change',
          },
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      dialogVisible: false,
      dialogVisibleZC: false,
      showCodeImg: false,
      //上传图片需要验证码参数
      codeUrlimg: '',
      regImgDisabled: true,
      regImgCode: '',
      uuidImg: '',
      timeStamp: '',
      zhucesuccess: false,
      mediaSc: '', //媒体注册手册
      codeUrl2: '',
    };
  },
  mounted() {
    this.getCodeImg();
    this.getMediaRegit();
  },
  methods: {
    uploadRegImg(list) {
      this.formData.regImg = list;
      console.log('上传的图片', this.formData.regImg);
      if (list) {
        this.$refs.formData.clearValidate(['regImg']);
      } else {
        // 如果图片被删除，重新获取验证码
        this.getCodeImg();
      }
    },
    handleZC() {
      this.dialogVisibleZC = true;
    },
    //上传图片的验证码
    getCodeImg() {
      getCodeImg().then((res) => {
        if (res.code == 200) {
          this.codeUrlimg = 'data:image/gif;base64,' + res.img;
          this.uuidImg = res.uuid;
          this.regImgCode = ''; // 清空之前的验证码输入
          this.regImgDisabled = true; // 禁用上传按钮，直到用户输入新的验证码
        }
      });
    },
    handleImageRemove() {
      this.formData.regImg = ''; // 清空图片数据
      this.getCodeImg(); // 更新验证码
      this.$message.info(
        '图片已删除，验证码已更新，请重新输入验证码后上传图片'
      );
    },
    // formData的验证码
    getCode() {
      getCodeImg().then((res) => {
        if (res.code == 200) {
          this.codeUrl2 = 'data:image/gif;base64,' + res.img;
          this.formData.uuid = res.uuid;
        }
      });
    },
    // 显示验证码
    getCodeBtn() {
      this.showCodeImg = true;
      this.getCode();
    },
    handleRegImgCode(value) {
      if (value) {
        this.regImgDisabled = false;
        this.timeStamp = new Date().getTime();
      }
    },
    handleOther(value) {
      if (value != '') {
        this.formData.applyType.push('@133456');
      } else {
        this.formData.applyType = this.formData.applyType.filter(
          (a) => a != '@133456'
        );
      }
    },
    //点击上传先填验证码
    handleHasUpload() {
      console.log('点击上传图片');
      if (this.regImgDisabled) {
        this.$message.error('请先填写图片验证码');
      } else {
        // 如果用户删除了图片，重新获取验证码
        this.getCodeImg();
      }
    },
    //注册须知
    getMediaRegit() {
      getMediaRegistryConfig({ siteId: this.$store.state.siteValue }).then(
        (res) => {
          if (res.code == 200) {
            this.mediaSc = res.data.records[0];
          }
        }
      );
    },

    onSubmit() {
      let array = [...this.formData.applyType];
      if (this.other != '') {
        array.push(this.other);
      }
      this.formData.applyType = [...new Set(array)];
      this.formData.applyType = this.formData.applyType.filter(
        (a) => a != '@133456'
      );
      this.$refs.formData.validate((valid) => {
        if (valid) {
          if (!this.formData.zhuce) {
            return this.$message.error('请勾选我已阅读媒体注册须知');
          }
          let data = {
            ...this.formData,
            checkInTime: this.formData.date[0],
            leaveTime: this.formData.date[1],
            applyType: this.formData.applyType.join(','),
            siteId: this.$store.state.siteValue,
            siteId: this.$store.state.siteValue,
          };
          addMediaRegistry(newproxyPut(data)).then((res) => {
            if (res.code == 200) {
              this.zhucesuccess = true;
            }
          });
        } else {
          return false;
        }
      });
    },
    toback() {
      this.$router.push({ path: '/' });
      this.zhucesuccess = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.content_con {
  width: 100%;
  box-sizing: border-box;
  padding: 0 1.3333rem 2.5rem;
  overflow: hidden;
  .form_con {
    background: #fff;
    .title_bg {
      width: 100%;
      object-fit: cover;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .title_w {
        margin-top: -0.3333rem;
        text-align: center;
        font-size: 0.6667rem;
      }
    }
    .title {
      text-align: center;
      font-size: 1.5rem;
      font-family: SourceHanSansCN-Medium;
      margin: 1rem 0 2rem 0;
    }
    .line {
      width: 100%;
      margin: 2rem 0;
      height: 0.125rem;
      background: linear-gradient(
        to right,
        rgba(170, 229, 239, 1),
        rgba(177, 187, 255, 1)
      );
    }
    .demo-formData {
      width: 100%;
      margin: 0 auto;
      .login-code {
        width: 40%;
        height: 40px;
        float: right;
        img {
          width: 100%;
          height: 100%;
          cursor: pointer;
          vertical-align: middle;
        }
      }
    }
    .form_title {
      font-family: SourceHanSansCN-Medium;
      font-size: 1.3333rem;
      color: #363a44;
      margin-left: 0.5rem;
      margin-bottom: 0.5rem;
    }
  }
  .success_con {
    margin: 22% auto;
    text-align: center;
    img {
      width: 13.3333rem;
      height: auto;
    }
    .succsee_title {
      font-size: 1.5rem;
      font-family: SourceHanSansCN-Medium;
    }
    .succsee_word {
      color: #b9bcbf;
      font-size: 1.1667rem;
      margin: 0.625rem 0;
      span {
        color: #424451;
        margin-left: 0.3125rem;
      }
    }
  }
}
::v-deep {
  .el-input__inner {
    background: none;
    border: none;
  }
  .el-dialog__header {
    border-top: 0.3125rem solid;
    border-image: linear-gradient(
        to right,
        rgba(170, 229, 239, 1),
        rgba(177, 187, 255, 1)
      )
      6 6;
  }
  .el-dialog__body {
    position: relative;
    padding-top: 0;
  }
  .el-dialog__title {
    font-size: 2.25rem;
    font-family: SourceHanSansCN-Medium;
    padding-top: 1.875rem;
  }
  .vertical-layout {
    display: block;
  }
  .vertical-layout .el-form-item__label {
    display: block;
    padding-bottom: 8px;
  }
  .vertical-layout .el-form-item__content {
    margin-left: 0 !important;
  }
  .el-form-item {
    border-bottom: solid #e8e9ec 1px;
    padding-bottom: 0.4167rem;
  }
  .el-upload--picture-card i {
    color: #165dff;
  }
}
.dialog_content {
  width: 90%;
  height: 40vh;
  margin: 0 auto;
  line-height: 1.8333rem;
  font-size: 1rem;
  overflow-y: scroll;
  color: #6b6d7a;
}
.dialog_btn {
  width: 100%;
  position: absolute;
  height: 4.1667rem;
  line-height: 4.1667rem;
  background: #fff;
  bottom: 0;
  left: 0;
  text-align: center;
  color: #1e92f0;
  font-size: 1.5rem;
}
</style>
